import store from '@/store'
import toastMaker, { toastActions } from '@/utils/toast-maker'
import { cloneDeep } from '@/plugins/cloneDeep'
export default service => {
  service.on('created', (result, context) => {
    // Add full dot to store
    const dot = cloneDeep(result)
    const { toast } = dot
    store.commit('dots/add', dot)
    store.commit('dots/fresh', dot.id)

    // Add core fields to page
    store.commit('pages/dots/add', extractDotForPage(dot))
    store.commit('dots/fresh', dot.id)
    console.log('do we have toast?!?', toast)
    // Send toast
    if (toast) {
      toastMaker.toast(toast, store)
    }
  })

  service.on('updated', (result, context) => {
    const { toast } = result
    console.log('dot updated', result)
    store.commit('pages/dots/add', extractDotForPage(result))
    store.commit('dots/add', result)
    store.commit('dots/fresh', result.id)
    console.log('do we have toast?!?', toast)

    if (toast) {
      toastMaker.toast(toast, store)
    }
  })
}

const extractDotForPage = dot => {
  const dotForPage = cloneDeep(dot)
  delete dotForPage.card
  delete dotForPage.pages
  delete dotForPage.browsers
  delete dotForPage.toast
  return dotForPage
}
